module.exports = __webpack_public_path__ + "img/animator-60x60.4fe5da5e.png";